// sessionStorage key holding the patients page's search state (query, page,
// DOB range, active filter).
//
// Shared because two places now write it: the patients page itself, and the
// global search in the top nav. It was a private constant inside
// Pages/Patients/MainPage while that page was the only owner — two copies of a
// storage key is exactly the kind of thing that drifts silently.
export const PATIENT_SEARCH_STATE_KEY = "PATIENT_SEARCH_STATE";
